import styled from 'styled-components';
import { colors } from '../../variables/colors.js';

var Picture = styled.picture.withConfig({
  displayName: "style__Picture",
  componentId: "sc-8cftfh-0"
})(["align-items:center;display:inline-flex;justify-content:center;width:100%;img{flex:none;}"]);
var PictureReplacement = styled.div.withConfig({
  displayName: "style__PictureReplacement",
  componentId: "sc-8cftfh-1"
})(["align-items:center;display:inline-flex;justify-content:center;background-color:", ";flex-grow:1;height:100%;width:100%;.sg-picture-icon{fill:", ";}"], colors.lightGray, colors.darkGrayL1);

export { Picture, PictureReplacement };
//# sourceMappingURL=style.js.map
